import React from 'react'



const HowToResubscribe = () => {
    return (
        <>
            <div className="bg-light">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h3 className="mb-3">Comment se reabonner ?</h3>
                        <p className="text-muted lead">Ne laissez pas vos avantages s’arrêter ici ! Réabonnez-vous dès maintenant pour continuer à profiter de nos services exclusifs et simplifier votre quotidien.</p>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="card feature-card h-100 p-4">
                                <div className="icon-wrapper bg-soft-primary">
                                    <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"
                                        className="text-primary">
                                        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                                    </svg>
                                </div>
                                <h4 className="card-title">Paiement</h4>
                                <p className="card-text text-muted">Veuillez effectuer la transaction selon l'option de votre choix.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card feature-card h-100 p-4">
                                <div className="icon-wrapper bg-soft-success">
                                    <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"
                                        className="text-success">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                                    </svg>
                                </div>
                                <h4 className="card-title">Confirmation</h4>
                                <p className="card-text text-muted">Veuillez nous faire parvenir le reçu de la transaction.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card feature-card h-100 p-4">
                                <div className="icon-wrapper bg-soft-warning">
                                    <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"
                                        className="text-warning">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                    </svg>
                                </div>
                                <h4 className="card-title">Activations des services</h4>
                                <p className="card-text text-muted">Vos services seront activés dans les heures qui suivront votre réabonnement.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default HowToResubscribe